// @flow

export default class RexCampaignEntryButtonStatusProvider {
  constructor(getReduxState) {
    this.getReduxState = getReduxState;
  }

  __getStateByCId(cId) {
    if (!cId) return null;
    return this.getReduxState().buttonStateByCId[cId];
  }

  getIsLoggedInByCId(cId) {
    /* eslint-disable no-underscore-dangle */
    if (!cId || !this.__getStateByCId(cId)) return null;
    return this.__getStateByCId(cId).isLoggedIn;
    /* eslint-disable no-underscore-dangle */
  }

  getButtonStateByCId(cId) {
    /* eslint-disable no-underscore-dangle */
    if (!cId || !this.__getStateByCId(cId)) return null;
    return this.__getStateByCId(cId).buttonState;
    /* eslint-disable no-underscore-dangle */
  }
}



// WEBPACK FOOTER //
// ./src/components/RexCampaignEntryButtonStatusProvider.js